export default "__VITE_ASSET__BYx55T8a__"